export const DEFAULT_VOICE = "Kore";

export const VOICES = Object.freeze([
  { id: "Kore", label: "Kore", note: "Calda e sicura" },
  { id: "Puck", label: "Puck", note: "Allegra e vivace" },
  { id: "Zephyr", label: "Zephyr", note: "Chiara e luminosa" },
  { id: "Charon", label: "Charon", note: "Pacata e spiegata bene" },
  { id: "Leda", label: "Leda", note: "Giovane e frizzante" },
  { id: "Aoede", label: "Aoede", note: "Leggera e rilassata" },
  { id: "Callirrhoe", label: "Callirrhoe", note: "Tranquilla e gentile" },
  { id: "Enceladus", label: "Enceladus", note: "Morbida e sussurrata" },
  { id: "Algieba", label: "Algieba", note: "Vellutata e profonda" },
  { id: "Despina", label: "Despina", note: "Scorrevole e dolce" },
  { id: "Erinome", label: "Erinome", note: "Pulita e precisa" },
  { id: "Sulafat", label: "Sulafat", note: "Avvolgente e amichevole" }
]);

export const isVoice = (id) => VOICES.some((voice) => voice.id === id);

export const voiceById = (id) => VOICES.find((voice) => voice.id === id) || VOICES[0];
